import MainLayout from "components/templates/MainLayout"
import SettingsCards from "./SettingsCards"

const SettingsTemplate = () => (
  <MainLayout navigation>
    <SettingsCards />
  </MainLayout>
)

export default SettingsTemplate